export const environmentBase = {
  TSI_CONFIGURACION: 'url_configuracion',
  TSI_CONFIGURACION_PRUEBA: 'url_configuracion',
  TSI_PLANILLA: 'url_planilla',
  TSI_PLANILLA_PRUEBA: 'url_planilla',
  TSI_MODIFICACIONES: 'url_modificaciones',
  TSI_MODIFICACIONES_PRUEBA: 'url_modificaciones',
  TSI_CRM: 'url_crm',
  TSI_CRM_PRUEBA: 'url_crm',
  TSI_CONTROL_ASISTENCIA: 'url_control_asistencia',
  TSI_CONTROL_ASISTENCIA_PRUEBA: 'url_control_asistencia',
  TSI_CONTROL_VERSIONES: 'url_control_versiones',
  TSI_CONTROL_VERSIONES_PRUEBA: 'url_control_versiones',
  TSI_LAVANDERIA: 'url_lavanderia',
  TSI_LAVANDERIA_PRUEBA: 'url_lavanderia',
  TSI_DECLARACIONES_TRIBUTOS: 'url_declaraciones_tributos',
  TSI_DECLARACIONES_TRIBUTOS_PRUEBA: 'url_declaraciones_tributos',
  TSI_PROD: 'url_prod',
  TSI_PROD_PRUEBA: 'url_prod',
  TSI_SOPORTE:'url_soporte',
  TSI_SOPORTE_PRUEBA:'url_soporte',
  TSI_IMPORTACIONES: 'url_importaciones',
  TSI_IMPORTACIONES_PRUEBA: 'url_importaciones',
  TSI_RENDICIONES: "url_rendiciones",
  TSI_RENDICIONES_PRUEBA: "url_rendiciones",
  TSI_ACTIVOS: 'url_activos',
  TSI_ACTIVOS_PRUEBA: 'url_activos',
  TSI_PUNTO_VENTA: 'url_punto_venta',
  TSI_PUNTO_VENTA_PRUEBA: 'url_punto_venta',
  TSI_HERRAMIENTAS: 'url_herramientas',
  TSI_HERRAMIENTAS_PRUEBA: 'url_herramientas',
  NEW_TSI: "url_new_erp",
  NEW_TSI_PRUEBA: "url_new_erp"
}